import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

const Home = () => {
  const auth = useSelector(state => state["authentification"]);
  const history = useHistory();

  useEffect(() => {
    history.push("/equipements");
  }, [auth.profil]);

  return (
    <div></div>
  );
}

export default Home;